import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { CustomizedLabelProps, DataType } from './DonutChart.type';
import { useAppColors } from '@/hooks/useAppColors';
import { CustomTooltip } from './CustomTooltip';
import { CustomLegend } from './CustomLegend';

export const DonutChart = ({ data }: { data: DataType[] }) => {
  const COLORS = useAppColors();
  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx, cy, midAngle, outerRadius, percent,
  }: CustomizedLabelProps) => {
    const radius = outerRadius - 30;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        fontSize={12}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        className='font-medium'
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  if (!data?.length || !COLORS.length) return null;

  return (
    <div className="w-full flex justify-center min-h-[200px] shadow-neumorph rounded-md">
      <div className="flex flex-col lg:items-start w-full">
        {/* Gráfica */}
        <div className="min-w-[200px] h-[200px] w-full mt-4">
          <ResponsiveContainer width="100%" height="100%" maxHeight={200}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
              >
                {data.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Leyenda */}
        <CustomLegend data={data} colors={COLORS} />
      </div>
    </div>
  );

};
